"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _lodash = _interopRequireDefault(require("lodash"));

var _log = _interopRequireDefault(require("../../log.js"));

var _GatewayService = _interopRequireDefault(require("../../GatewayService.js"));

var _errors = require("../../errors.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var feedback = new _GatewayService["default"]('feedbacktwo');

var stringifyUsers = function stringifyUsers(userKeys) {
  return userKeys.join(',');
};

var fetchUnsentFeedbackCountForCardstack = function fetchUnsentFeedbackCountForCardstack(cardstackKey) {
  var userKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  if (_lodash["default"].isEmpty(cardstackKey)) {
    _log["default"].error('Not fetching unsent feedback count because no cardstackKey was specified');

    return Promise.reject((0, _errors.missingParam)('cardstackKey'));
  }

  if (_lodash["default"].isEmpty(userKeys)) {
    _log["default"].error('Not fetching unsent feedback count no users were specified');

    return Promise.reject((0, _errors.missingParam)('userKeys'));
  }

  return feedback.post("bulk/unsentCount/".concat(cardstackKey), stringifyUsers(userKeys), {
    headers: {
      'Content-Type': 'text/plain'
    }
  })["catch"](function (err) {
    _log["default"].warn('Unable to retrieve unsent feedback counts: ', err);

    throw err;
  });
};

var fetchUnsentFeedbackCountForClass = function fetchUnsentFeedbackCountForClass(classKey) {
  var cardstacksKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var userKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  if (_lodash["default"].isEmpty(classKey)) {
    _log["default"].error('Not fetching unsent feedback count because no classKey was specified');

    return Promise.reject((0, _errors.missingParam)('cardstackKey'));
  }

  if (_lodash["default"].isEmpty(cardstacksKeys)) {
    _log["default"].error('Not fetching unsent feedback count because no cardstackKey was specified');

    return Promise.reject((0, _errors.missingParam)('cardstackKey'));
  }

  if (_lodash["default"].isEmpty(userKeys)) {
    _log["default"].error('Not fetching unsent feedback count no users were specified');

    return Promise.reject((0, _errors.missingParam)('userKeys'));
  }

  var data = {
    userKeys: userKeys,
    cardstacksKeys: cardstacksKeys,
    classKey: classKey
  };
  return feedback.post("bulk/unsentCount", data, {
    headers: {
      'Content-Type': 'application/json'
    }
  })["catch"](function (err) {
    _log["default"].warn('Unable to retrieve unsent feedback counts: ', err);

    throw err;
  });
};

var submitAllFeedbackForCardstack = function submitAllFeedbackForCardstack(unitKey, cardstackKey) {
  var userKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var classKey = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

  if (_lodash["default"].isEmpty(unitKey)) {
    _log["default"].error('Not bulk submitting feedback because no unitKey was specified');

    return Promise.reject((0, _errors.missingParam)('unitKey'));
  }

  if (_lodash["default"].isEmpty(cardstackKey)) {
    _log["default"].error('Not bulk submitting feedback because no cardstackKey was specified');

    return Promise.reject((0, _errors.missingParam)('cardstackKey'));
  }

  if (_lodash["default"].isEmpty(userKeys)) {
    _log["default"].error('Not bulk submitting feedback because no users were specified');

    return Promise.reject((0, _errors.missingParam)('userKeys'));
  }

  var queryString = classKey ? "?classBusinessKey=".concat(classKey) : '';
  return feedback.post("bulk/submitAll/".concat(unitKey, "/").concat(cardstackKey).concat(queryString), stringifyUsers(userKeys), {
    headers: {
      'Content-Type': 'text/plain'
    }
  })["catch"](function (err) {
    _log["default"].warn('Unable to submit all feedback: ', err);

    throw err;
  });
};

var fetchAllUnreadFeedback = function fetchAllUnreadFeedback(unitKeys) {
  if (_lodash["default"].isEmpty(unitKeys)) {
    _log["default"].error('Unable to fetch unread feedback because no units were specified');

    return Promise.reject((0, _errors.missingParam)('unitKeys'));
  }

  return feedback.post("bulk/unreadFeedback/breadcrumbs", unitKeys, {
    headers: {
      'Content-Type': 'application/json'
    }
  })["catch"](function (err) {
    _log["default"].warn('Unable to retrieve unread feedback: ', err);

    throw err;
  });
};

var _default = {
  fetchUnsentFeedbackCountForCardstack: fetchUnsentFeedbackCountForCardstack,
  fetchUnsentFeedbackCountForClass: fetchUnsentFeedbackCountForClass,
  submitAllFeedbackForCardstack: submitAllFeedbackForCardstack,
  fetchAllUnreadFeedback: fetchAllUnreadFeedback
};
exports["default"] = _default;